import { AfterViewInit, Component } from "@angular/core";
import { MagicDeckGroups } from "./magic-deck-groups";
import { MagicDeckGroupComponent } from "./magic-deck-group.component";
import { NgClass } from "@angular/common";
import { DeckLayerComponent } from "@ponder-features/user/decks/deck/deck-layer.component";

@Component({
    selector: "magic-deck-layer",
    imports: [MagicDeckGroupComponent, NgClass],
    templateUrl: "./magic-deck-layer.component.html"
})
export class MagicDeckLayerComponent extends DeckLayerComponent implements AfterViewInit {
    public override ngOnInit(): void {
        super.ngOnInit();
        this.createCardGroups();
    }

    public ngAfterViewInit(): void {
        this.onScreenResize();
    }
    
    private createCardGroups(): void {
        this.groups = new MagicDeckGroups(this.deck, this.columnCount);
        this.groups.addCards(this.deckLayer.cards!);
    }

    protected override onScreenResize(): void {
        super.onScreenResize();
        this.groups.setColumnCount(this.columnCount);
    }
}